/**
 * DCTL-2701. The web copy of the api's WPD_SPLIT_UUID_NAMESPACE
 * (api/app/services/Dactylizer/wpdSplitUuidNamespace.ts). The Dactylizer gives
 * each data half of a WPD cell split across tag groups the uuid
 * `uuidv5(`${point uuid}:${tag group uuid}`, namespace)`; the reverse lookup in
 * `findDataPointByUuid` derives the same uuids to take a QC deep link back to
 * the WPD point. The two copies are pinned equal by wpdSplitUuid.test.js.
 *
 * NEVER change this value: every derived uuid already in a tree, a QC decision
 * or a finalized IA would stop resolving.
 */
export const WPD_SPLIT_UUID_NAMESPACE = "245f5c7c-453d-491a-a52c-58a8f984ca6f";
